import { Capacitor } from '@capacitor/core';
import { Component, State, Watch, Method, h } from '@stencil/core';
import { Unsubscribe } from 'redux';
import SworkitMobile from '../../../../global/sworkit-mobile/sw-mobile';
import { store } from '../../../../store';

@Component({
  tag: 'sw-audio',
  styleUrl: 'sw-audio.scss',
})
export class SwAudio {
  unsubscribe: Unsubscribe;
  private audioEl: HTMLAudioElement;
  private promise: Promise<any>;
  @Method()
  async playAudio(audio: string | string[]) {
    try {
      await this.promise;
      if (Array.isArray(audio)) {
        for (const url of audio) {
          //console.debug(`playing audio`, url)
          await this.loadAndPlayAudio(url);
        }
      } else {
        await this.loadAndPlayAudio(audio);
        // console.debug('playing 1/1 audio:', audio)
      }
    } catch (err) {
      console.error('error loading & playing audio', err);
      this.promise = null;
      return;
    }
  }
  @Method()
  async clearAudio() {
    this.promise = null;
  }
  @Method()
  async resumeAudio() {
    this.audioEl.play();
  }
  @Method()
  async pauseAudio() {
    this.audioEl.pause();
  }

  @State() volume: number;
  @Watch('volume')
  volumeChanged() {
    this.adjustVolume();
  }
  @State() muted: boolean;

  async componentWillLoad() {
    this.unsubscribe = store.mapStateToProps(this, (state: SworkitState) => {
      const {
        localSettings: { volume, muted },
      } = state;
      return {
        volume,
        muted,
      };
    });
    this.adjustVolume();
  }

  componentDidLoad() {
    this.adjustVolume();
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  adjustVolume() {
    if (this.audioEl || Capacitor.isNativePlatform()) {
      SworkitMobile.setAudioVolume({ volume: this.volume, externalAudioPlayer: this.audioEl })
    }
  }

  loadAndPlayAudio(audioUrl: string) {
    if (!audioUrl) return;
    try {
      this.promise = new Promise((resolve, reject) => {
        this.audioEl.src = audioUrl;
        this.audioEl.preload = 'auto';
        this.audioEl.play();
        this.audioEl.onended = () => {
          this.audioEl.src = '';
          resolve(null);
        };
        this.audioEl.onerror = reject;
      });
      return this.promise;
    } catch (err) {
      console.debug('error loading and playing audio', err);
    }
  }

  render() {
    return (
      <audio
        id="exercise-audio"
        ref={(ref) => (this.audioEl = ref)}
        muted={this.muted}
      >
        <source type="audio/mp3" /> Your browser does not support the audio
        format.
      </audio>
    );
  }
}
